class InputTags {
    constructor(el) {
        this.input = el.querySelector('input');
        this.tagsEl = el.querySelector('.InputTags__tags');
        this.name = el.dataset.name;

        el.querySelector('.InputBase__icon').addEventListener('click', this.addTag.bind(this));
        this.input.addEventListener('keypress', (e) => {
            if(e.key === 'Enter') this.addTag();
        }, {passive: true});
        this.input.addTag = this.addTag.bind(this);
    }

    addTag(name = this.input.value.trim()) {
        if(name.length) {
            this.tagsEl.append(this.getTagEl(name))
            this.input.value = '';
        }
    }

    getTagEl(name) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.value = name;
        input.name = this.name;

        const div = document.createElement('div');
        div.className = 'tag tag--bg tag--small tag--close';
        div.innerHTML = name;
        div.append(input);

        div.addEventListener('click', () => div.remove());

        return div;
    }
}


document.querySelectorAll('.InputTags').forEach((el) => {
    new InputTags(el);
})
